




































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { generateOptions } from '../detailSheetUtils';
import { exportExcelByArray } from '@/utils/other';

type IDataInfo = IReport.IDetailSheet.IDataInfo;

const titleColumn = {
  dataIndex: 'title',
  slots: { title: 'titleTitle' },
  ellipsis: true,
  width: 250,
  fixed: 'left',
  scopedSlots: {
    customRender: 'titleValue',
    filterDropdown: 'filterDropdown',
    filterIcon: 'filterIcon',
  },
  onFilter: (value: string, record: IDataInfo) => {
    return record.title.toString().toLowerCase().includes(value.toLowerCase());
  },
};
const moduleColumn = {
  dataIndex: 'moduleTitle',
  slots: { title: 'moduleTitle' },
  width: 250,
  ellipsis: true,
  fixed: 'left',
  scopedSlots: {
    customRender: 'moduleTitleValue',
    filterDropdown: 'filterDropdown',
    filterIcon: 'filterIcon',
  },
  onFilter: (value: string, record: IDataInfo) => {
    return record.moduleTitle.toString().toLowerCase().includes(value.toLowerCase());
  },
};
const dueColumn = {
  dataIndex: 'due',
  slots: { title: 'dueTitle' },
  width: '12%',
  align: 'center',
  sorter: (a: IDataInfo, b: IDataInfo) => {
    return new Date(a.due).valueOf() - new Date(b.due).valueOf();
  },
};
const manDayColumn = {
  dataIndex: 'manDay',
  slots: { title: 'manDayTitle' },
  width: '6%',
  align: 'center',
  sorter: (a: IDataInfo, b: IDataInfo) => a.manDay - b.manDay,
};
const isBonusColumn = {
  dataIndex: 'isBonus',
  slots: { title: 'bonusTitle' },
  scopedSlots: { customRender: 'bonus' },
  width: '8%',
  align: 'center',
  filters: [{text: 'Yes', value: 'Yes'}, {text: 'No', value: 'No'}],
  onFilter: (value: string, record: IDataInfo) => (value === 'Yes') === record.isBonus,
};
const projectColumn = {
  dataIndex: 'projectName',
  slots: { title: 'projectTitle' },
  width: '6%',
  ellipsis: true,
};
const settlementDateColumn = {
  dataIndex: 'settlementDate',
  slots: { title: 'settlementDateTitle' },
  width: '8%',
  sorter: (a: IDataInfo, b: IDataInfo) => {
    return new Date(a.settlementDate).valueOf() - new Date(b.settlementDate).valueOf();
  },
};

@Component
export default class DetailTable extends Vue {
  @Prop({required: true}) private spinning!: boolean;
  @Prop({required: true}) private sheetData!: IDataInfo[];
  private currentRow: IDataInfo | null = null;
  private currentPage = 1;
  private pagination = {
    pageSize: 15,
    hideOnSinglePage: true,
  };
  private searchInput = null;
  private searchText = '';
  private searchedColumn = '';
  private exportData: IDataInfo[] = [];
  get activeId(): string {
    return this.currentRow?.id || '';
  }
  get columns() {
    // generateKeysAndTheads方法 有用到 columns
    // 要求column 有column.slots.title、dataIndex屬性
    // 滿足 this.$t(`report.${column.slots.title.replace('Title', '')}` 的條件
    const {
      typeOption,
      ownerOption,
      statusOption,
      creatorOption,
      settlementUnitOption,
      quotationCategoryOption,
    } = generateOptions(this.sheetData);
    const typeColumn = {
      dataIndex: 'typeName',
      width: '8%',
      slots: { title: 'todoTypeTitle' },
      filters: typeOption,
      onFilter: (value: string, record: IDataInfo) => {
        return record.typeId === value;
      },
      ellipsis: true,
    };
    const ownerColumn = {
      dataIndex: 'followName',
      slots: { title: 'ownerTitle' },
      width: '8%',
      filters: ownerOption,
      onFilter: (value: string, record: IDataInfo) => record.owner === value,
    };
    const statusColumn = {
      dataIndex: 'status',
      slots: { title: 'statusTitle' },
      width: '7%',
      align: 'center',
      filters: statusOption,
      onFilter: (value: string, record: IDataInfo) => record.status === value,
    };
    const createrColumn = {
      dataIndex: 'createdName',
      slots: { title: 'creatorTitle' },
      width: '8%',
      filters: creatorOption,
      onFilter: (value: string, record: IDataInfo) => record.createdBy === value,
    };
    const settlementUnitColumn = {
      dataIndex: 'settlementConfigurationName',
      slots: { title: 'settlementUnitTitle' },
      width: '8%',
      filters: settlementUnitOption,
      onFilter: (value: string, record: IDataInfo) => {
        if (record.settlementConfigurationName === null) {
          return value === 'NULL';
        }
        return record.settlementConfigurationName === value;
      },
    };
    const quotationCategoryColumn = {
      dataIndex: 'quotationCategoryNames',
      slots: { title: 'quotationCategoryTitle' },
      width: '8%',
      scopedSlots: { customRender: 'quotationCategoryNames' },
      filters: quotationCategoryOption,
      onFilter: (value: string, record: IDataInfo) => {
        if (record.quotationCategoryNames.length === 0) {
          return value === 'NULL';
        }
        return record.quotationCategoryNames.includes(value);
      },
    };
    return [
      titleColumn,
      moduleColumn,
      createrColumn,
      typeColumn,
      ownerColumn,
      dueColumn,
      statusColumn,
      manDayColumn,
      projectColumn,
      quotationCategoryColumn,
      settlementUnitColumn,
      settlementDateColumn,
      isBonusColumn,
    ];
  }
  public exportExcel(dates: string[]) {
    if (this.exportData.length === 0) {
      this.$message.warning(this.$t('report.notExport').toString());
      return;
    }
    const fileName = `detail(${dates.join('To')}).xlsx`;
    const {keys, thead} = this.generateKeysAndTheads();
    const formatJson = (filterKey: string[], jsonData: IDataInfo[]) => {
      return jsonData.map((item) => {
        return filterKey.map((key) => {
          if (item[key as keyof IDataInfo] && Array.isArray(item[key as keyof IDataInfo])) {
            return item[key as keyof IDataInfo].toString();
          }
          return item[key as keyof IDataInfo];
        });
      });
    };
    const tbodyData = formatJson(keys, this.exportData);
    try {
      exportExcelByArray(fileName, thead, tbodyData);
    } catch (error) {
      this.$message.warning((error as Error).message);
    }
  }
  private generateKeysAndTheads() {
    const keys: string[] = [];
    const thead: string[] = [];
    this.columns.forEach((column) => {
      keys.push(column.dataIndex);
      thead.push(this.$t(`report.${column.slots.title.replace('Title', '')}`).toString());
    });
    return {
      keys,
      thead,
    };
  }
  @Watch('sheetData')
  private watchSheetData(newValue: IDataInfo[]) {
    this.exportData = newValue;
  }
  private handleTableChange(pagination: any, filters: any, sorter: any, data: {currentDataSource: IDataInfo[]}) {
    this.currentPage = pagination.current;
    this.exportData = data.currentDataSource;
  }
  private clickRow(row: IDataInfo) {
    this.currentRow = row;
  }
  private getRowClassName(row: IDataInfo, index: number): string {
    if (row.id === this.activeId) {
      return 'active';
    }
    return '';
  }
  private customRow(row: IDataInfo, index: number) {
    return {
      on: {
        click: (event: Event) => {
          this.clickRow(row);
        },
      },
    };
  }
  private handleSearch(selectedKeys: string[], confirm: () => void, dataIndex: string) {
    confirm();
    this.searchText = selectedKeys[0];
    this.searchedColumn = dataIndex;
  }
  private handleReset(clearFilters: () => void) {
    clearFilters();
    this.searchText = '';
  }
}
